import { applyOps, createPageDoc, Scene, toSvg } from '@flobi/artwork-core';
import type { CatalogItem } from '../../services/catalog';
import type { CatalogLayers } from '../useEditorCanvas';

/** Draw saved layers without depending on the background thumbnail service. */
export function catalogPreviewSvg(item: Pick<CatalogItem, 'id' | 'kind' | 'width' | 'height'>, layers: CatalogLayers): string {
  const page = createPageDoc(`catalog-preview-${item.id}`, 'preview');
  const scene = new Scene(page);
  try {
    const board = item.kind === 'template' ? layers.artwork.find(clip => clip.node.type === 'artboard') : null;
    const ops = layers.artwork.flatMap(clip => [
      { op: 'create', node: { ...clip.node, id: clip.id, ...(clip === board ? { transform: [1, 0, 0, 1, 0, 0] } : clip.world ? { transform: clip.world } : {}) } },
      ...clip.children.map(child => ({ op: 'create', parentId: child.parent, node: { ...child.node, id: child.id } })),
    ]);
    const result = applyOps(page, ops, { scene });
    if (!result.ok || layers.artwork.length === 0) throw new Error('The saved graphic could not be previewed.');
    return toSvg(scene, {
      ...(board ? { artboardId: board.id } : { region: { x: 0, y: 0, width: item.width, height: item.height } }),
      indent: false,
      assetUrl: id => {
        const asset = layers.resources?.assets?.[id] as { src?: unknown } | undefined;
        return typeof asset?.src === 'string' ? asset.src : null;
      },
    });
  } finally {
    scene.dispose();
    page.destroy();
  }
}
